import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, Inject, PLATFORM_ID, ViewChild, Input, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SocialService } from '../socials/socials.service';
import { Social } from './social.model';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-socials',
  templateUrl: 'socials.component.html',
  styleUrls: ['socials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SocialsComponent implements OnInit {

  public slug: string;
  public page: any;
  public pageIndex = 1;
  public pageTotal = -1;
  public posts: any[];
  public cdn = environment.cdn;

  public loading$= new BehaviorSubject<boolean>(true);
  public posts$ = new BehaviorSubject<Social[]>([]);

  @HostListener('window:scroll',['$event'])
  onWindowScroll(event:any){
    if(window.innerHeight+window.scrollY >= (document.body.offsetHeight - document.body.offsetHeight/4) && !this.loading$.value && this.pageIndex < this.pageTotal){
      this.pageIndex++;
      this.fetchSocial();
    }
  }

  constructor(@Inject(PLATFORM_ID) private platformId: string, private router: Router, private route: ActivatedRoute, private socialsService: SocialService, private cdr: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.page = this.route.snapshot.data;
    this.fetchSocial();
    // this.posts$ = this.socialsService.items({ page: 1, pagesize: 12 });

  }

  fetchSocial() {
    this.loading$.next(true);
    this.socialsService.items({ page: this.pageIndex, pagesize: 9 }).subscribe(posts => {
      if (this.pageTotal < 0) this.pageTotal = posts.pages.pageCount;
      let posts_acc = this.posts$.value;
      posts_acc.push(...posts.items);
      this.posts$.next(posts_acc);
      this.loading$.next(false);
    });
  }

}
